(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-care-sub"]) return;
  try {
    
	document.addEventListener("DOMContentLoaded", function () {
    const panelTitles = document.querySelectorAll('.tab-item .h2');

    panelTitles.forEach(title => {
      title.addEventListener('click', function () {
        const nextElement = this.nextElementSibling;
        if (nextElement) {
          const isVisible = window.getComputedStyle(nextElement).display !== 'none';
          nextElement.style.display = isVisible ? 'none' : 'block';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-care"]) return;
  try {
    
				document.addEventListener("DOMContentLoaded", function () {
          const tablist = document.querySelectorAll('.customer-navigation .icon_tab-link');
          const panels = document.querySelectorAll('.tabs-content .tab-item');

          const removeClassFromElements = (elements, className) => {
            elements.forEach(el => el.classList.remove(className));
          };

          const addClass = (el, className) => {
            if (el) el.classList.add(className);
          };

          const activeTab = function (link, tab) {
            removeClassFromElements(tablist, 'is-active');
            addClass(link, 'is-active');

            removeClassFromElements(panels, 'is-active');
            addClass(tab, 'is-active');
          };

          tablist.forEach(link => {
            link.addEventListener('click', function (e) {
              e.preventDefault();
              const tabToShowSelector = this.getAttribute('href');
              const tabToShow = document.querySelector(tabToShowSelector);

              if (tabToShow && !tabToShow.classList.contains('is-active')) {
                removeClassFromElements(tablist, 'is-active');
                this.classList.add('is-active');

                removeClassFromElements(panels, 'is-active');
                tabToShow.classList.add('is-active');
              }
            });
          });

          const panelTitles = document.querySelectorAll('.tab-item .h2');

          panelTitles.forEach(title => {
            title.addEventListener('click', function () {
              const nextElement = this.nextElementSibling;
              if (nextElement) {
                if (nextElement.style.display === 'block') {
                  nextElement.style.display = 'none';
                } else {
                  nextElement.style.display = 'block';
                }
              }
            });
          });

          // Activate tab if hash is present in URL
          if (window.location.hash) {
            const hash = window.location.hash.substring(1);
            const tabSelector = '#' + hash;
            const tab = document.querySelector(tabSelector);
            const link = document.querySelector(`a[href$="${tabSelector}"]`);

            if (tab && !tab.classList.contains('is-active')) {
              activeTab(link, tab);
            }
          }
        });
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["delivery"]) return;
  try {
    
	$(document).ready(function(){
		var $panelTitles = $('.rte h2');

		$panelTitles.each(function(){
			$(this).on('click', function(){
				if ($(this).next().is(':visible')) {
					$(this).next().css('display','none')
				} else {
					$(this).next().css('display','block')
				}
			});
		});
	});

  } catch(e) { console.error(e); }
})();
})();
